import { render, staticRenderFns } from "./SignatureCanvas.vue?vue&type=template&id=8d808188"
import script from "./SignatureCanvas.vue?vue&type=script&lang=ts"
export * from "./SignatureCanvas.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports